module.exports = __webpack_public_path__ + "static/media/malagahoy.f81f9b61.png";